import styled from "styled-components";
import { TextField } from "@material-ui/core";

export const HiddenStyledTextField = styled(TextField)`
    display: none;
`;
